export default {
  productPrices: [],
  productPrice: undefined,
};
